/**
 * deletePasskey management call (Req 11.4)
 *
 * `DELETE /auth/passkey/credentials/:credentialId` を ApiClient 経由で発行する。
 * `@auth/client` ApiClient は公開 seam として `get` / `post` のみを持ち (`@auth/client`
 * 改修禁止 Req 11.6/11.7)、内部 `request` は `options.method` を verb より後に spread する
 * ため、`apiClient.get(path, { method: 'DELETE' })` で DELETE を発行できる。これにより
 * access-token 付与・`AuthError` 変換といった ApiClient の契約を維持したまま削除する。
 *
 * 成功時の wire は `204 No Content` (design.md §API Contract 911 行)。
 * ApiClient は常に応答 body を `.json()` するため、本物の空 body 204 では JSON parse が
 * 失敗し ApiClient 内で `AuthError('NETWORK_ERROR', ...)` に rewrap される。これは正常な
 * 削除成功であり、当該「成功 204 の空 body」ケースのみ吸収して `void` を返す。Hono の
 * `ctx.json(null, { status: 204 })` 経由で `null` body が届く実装差異では `.json()` が
 * `null` に解決するため、その場合は単にその値を捨てる。
 * 上記以外の HTTP error (404/409/401 等の `AuthError`) は再ラップせず伝播する。
 */
import { AuthError } from "@auth/client";
/**
 * 指定 credential を削除する。成功時 `void`。
 *
 * @param apiClient `@auth/client` の ApiClient (inject 経由)
 * @param credentialId 削除対象の base64url credential ID
 */
export async function deletePasskey(apiClient, credentialId) {
    const path = `/auth/passkey/credentials/${encodeURIComponent(credentialId)}`;
    try {
        // ApiClient の method override seam (verb を DELETE に差替え)。body は不要。
        await apiClient.get(path, { method: "DELETE" });
    }
    catch (error) {
        // 成功 204 の空 body は ApiClient 内で JSON parse 失敗 → NETWORK_ERROR に rewrap される。
        // これは削除成功なので吸収する。それ以外の AuthError / error はそのまま伝播。
        if (isEmptyBodyParseError(error)) {
            return;
        }
        throw error;
    }
}
/**
 * 「成功 204 の空 body により ApiClient が rewrap した JSON parse 失敗」を判定する。
 *
 * ApiClient は body parse 失敗時に `AuthError('NETWORK_ERROR', <SyntaxError.message>)` を
 * throw する。空 body の `.json()` 失敗 message は実装環境で
 * "Unexpected end of JSON input" 等になる。
 */
function isEmptyBodyParseError(error) {
    return (error instanceof AuthError && error.code === "NETWORK_ERROR" && /json/i.test(error.message));
}
//# sourceMappingURL=delete-passkey.js.map